import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { LocationOption } from '../models/location-option.interface';

export const locationOptionActions = createEagerSelectActions<LocationOption>('[Location Options]');
